import ApiDatabase from 'server';
import UseContext from 'hooks/useContext';
import Modalheader from 'components/modal/components/header';
import ModalBody from 'components/modal/components/body';
import PerimeterAccessAlert from 'components/modal/dataModal/data/perimeter/PerimeterAccessAlert';
import PerimeterModalFooter from 'components/modal/dataModal/data/perimeter/PerimeterModalFooter';
import usePerimeterModal from 'components/modal/dataModal/data/perimeter/usePerimeterModal';
import { ARCHIVE_ERROR_OVERRIDES } from 'components/perimeter/perimeterErrors';
import { fillText, perimeterText } from 'components/perimeter/perimeterText';

// A perimeter that never carried a mission: deleted for good.
const DeletePerimeterModal = () => {
  const { language } = UseContext();
  const t = (key) => perimeterText(language, key);
  const { data, isSaving, setIsSaving, close, succeed, fail } =
    usePerimeterModal();
  const { idCompany, perimeter, usage } = data;
  const membersLeft = Number(usage?.membersLeftWithoutPerimeter) || 0;

  const handleConfirm = () => {
    if (isSaving) return;
    setIsSaving(true);
    ApiDatabase.deleteAdminCompanyPerimeter(
      { idCompany, id: perimeter?.id },
      () => succeed(t('toast.deleted')),
      (err) => fail(err, { overrides: ARCHIVE_ERROR_OVERRIDES }),
    );
  };

  return (
    <>
      <Modalheader hide={close} hideShow={true}>
        {fillText(t('delete.title'), { name: perimeter?.name })}
      </Modalheader>
      <ModalBody>
        <div className={'flex flex-col gap-4'}>
          <p className={'text-sm text-gray-600'}>{t('delete.description')}</p>
          {membersLeft > 0 ? (
            <PerimeterAccessAlert count={membersLeft} />
          ) : null}
        </div>
      </ModalBody>
      <PerimeterModalFooter
        confirmLabel={t('delete.confirm')}
        savingLabel={t('delete.deleting')}
        isSaving={isSaving}
        onCancel={close}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default DeletePerimeterModal;
